import { useEffect } from 'react';

const KAKAO_POSTCODE_SCRIPT_ID = 'kakao-postcode-script';
const KAKAO_POSTCODE_SCRIPT_SRC =
  'https://t1.kakaocdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
const KAKAO_POSTCODE_LOADED_ATTR = 'data-kakao-postcode-loaded';

function ensureKakaoPostcodeScript() {
  return new Promise((resolve, reject) => {
    if (typeof window === 'undefined') {
      reject(new Error('window is undefined'));
      return;
    }
    if (window.kakao && window.kakao.Postcode) {
      resolve();
      return;
    }

    const existing = document.getElementById(KAKAO_POSTCODE_SCRIPT_ID);
    if (existing) {
      if (existing.getAttribute(KAKAO_POSTCODE_LOADED_ATTR) === '1') {
        window.kakao && window.kakao.Postcode
          ? resolve()
          : reject(new Error('Kakao Postcode unavailable'));
        return;
      }
      existing.addEventListener('load', () => resolve());
      existing.addEventListener('error', () =>
        reject(new Error('Kakao postcode script load failed')),
      );
      return;
    }

    const script = document.createElement('script');
    script.id = KAKAO_POSTCODE_SCRIPT_ID;
    script.src = KAKAO_POSTCODE_SCRIPT_SRC;
    script.async = true;
    script.onload = () => {
      script.setAttribute(KAKAO_POSTCODE_LOADED_ATTR, '1');
      resolve();
    };
    script.onerror = () => reject(new Error('Kakao postcode script load failed'));
    document.body.appendChild(script);
  });
}

const useGetDaumPostCode = (updateAddress) => {
  useEffect(() => {
    ensureKakaoPostcodeScript().catch(() => {});
  }, []);

  const handleAddress = () => {
    const element_layer = document.getElementById('addressBox');
    if (!element_layer) return;

    ensureKakaoPostcodeScript()
      .then(() => {
        const kakao = window.kakao;
        new kakao.Postcode({
          oncomplete: (data) => {
            let address = '';
            if (data.userSelectedType === 'R') {
              address = data.roadAddress;
            } else {
              address = data.jibunAddress;
            }
            updateAddress({ address: address, zipcode: data.zonecode });
            element_layer.style.display = 'none';
          },
          width: '100%',
          height: '100%',
          maxSuggestItems: 5,
        }).embed(element_layer);

        element_layer.style.display = 'block';

        const width = 300;
        const height = 400;
        const borderWidth = 2;

        element_layer.style.width = `${width}px`;
        element_layer.style.height = `${height}px`;
        element_layer.style.border = `${borderWidth}px solid`;
        element_layer.style.left =
          ((window.innerWidth || document.documentElement.clientWidth) - width) /
            2 -
          borderWidth +
          'px';
        element_layer.style.top =
          ((window.innerHeight || document.documentElement.clientHeight) -
            height) /
            2 -
          borderWidth +
          'px';
      })
      .catch(() => {});
  };

  const closeDaumPostcode = () => {
    const element_layer = document.getElementById('addressBox');
    if (!element_layer) return;
    element_layer.style.display = 'none';
  };

  return { handleAddress, closeDaumPostcode };
};

export default useGetDaumPostCode;
